import React, { ReactNode } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAppState } from '../../state';

interface PrivateRouteProps extends RouteProps {
  children: ReactNode;
}

export default function PrivateRoute({ children, ...rest }: PrivateRouteProps) {
  const { isAuthReady, user } = useAppState();
  const renderChildren = user || !import.meta.env.REACT_APP_SET_AUTH;

  if (!renderChildren && !isAuthReady) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        renderChildren ? children : <Redirect to={{ pathname: '/login', state: { from: location } }} />
      }
    />
  );
}
